module.exports = new __parcel__URL__("Retro_Computer.13bc9d97.ttf").toString();